import './_postcard.scss';
import {useContext, useEffect, useRef, useState} from "react";
import {CardList} from "../cardList";

export default function Postcard({variant, onClose}) {
    const [isShown, setIsShown] = useState(true);
    const [imgUrl, setImgUrl] = useState('');
    const cardList = useContext(CardList);


    useEffect( () => {
        requestAnimationFrame(() => {
            setIsShown(!!variant)
        })
        setImgUrl(`./assets/img/postcards/${cardList[variant - 1]?.image}`);
    }, [variant])


    return <div className={'postcard ' + (!variant ? 'removed': '') + ' ' + (isShown ? 'visible': '')} style={{'backgroundImage': 'url('+imgUrl+')'}}>
        {/*<span style={{color: 'white' ,fontSize: '10vw', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>{variant}</span>*/}
        <div className="close" onClick={onClose}><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/><path fill="currentColor" d="m12 13.414l5.657 5.657a1 1 0 0 0 1.414-1.414L13.414 12l5.657-5.657a1 1 0 0 0-1.414-1.414L12 10.586L6.343 4.929A1 1 0 0 0 4.93 6.343L10.586 12l-5.657 5.657a1 1 0 1 0 1.414 1.414z"/></g></svg></div>
    </div>

}
